export default "__VITE_ASSET__C9YJgdLM__"